<template>
  <div class="info_box">
    <div class="owner_title">其余费用支出-新增</div>
    <div class="owner_box">
      <el-form
        ref="ownerFeeForm"
        :model="ownerFeeForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="姓名" prop="name">
          <el-input class="inpt_size" v-model="ownerFeeForm.name"></el-input>
        </el-form-item>
        <el-form-item label="支付宝" prop="alipay">
          <el-input class="inpt_size" v-model="ownerFeeForm.alipay"></el-input>
        </el-form-item>
        <el-form-item label="金额" prop="money">
          <el-input class="inpt_size" v-model="ownerFeeForm.money"></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remarks">
          <el-input class="inpt_size" v-model="ownerFeeForm.remarks"></el-input>
        </el-form-item>

        <el-form-item label="图片" prop="images">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :on-success="handleSuccess"
            :file-list="fileList"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button
            class="info_btn"
            type="primary"
            round
            @click="onSubmitOwnerInfo"
            >提交</el-button
          >
          <el-button class="info_btn" type="info" plain round @click="goBack"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { z_add } from "@/utils/api";
export default {
  data() {
    return {
      uploadUrl: this.$global.fileUploadUrl,
      ownerFeeForm: {
        departmentuser_id: "", //所属金主部id
        alipay: "", //支付宝
        images: "", //图片
        name: "", //姓名
        money: "", //金额
        remarks: "" //备注说明
      },
      rules: {
        name: { required: true, trigger: "blur", message: "姓名不能为空" },
        money: { required: true, trigger: "blur", message: "金额不能为空" },
        alipay: { required: true, trigger: "blur", message: "支付宝不能为空" }
      },
      fileList: [], //上传图片列表
      feeImgList: [], //
      dialogImageUrl: "", //图片路径
      dialogVisible: false,
      disabled: false
    };
  },
  created() {
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
  },
  methods: {
    //录入金主信息确认提交
    onSubmitOwnerInfo() {
      var that = this;
      that.$refs["ownerFeeForm"].validate(valid => {
        if (valid) {
          that.ownerFeeForm.departmentuser_id = that.ownerId;
          var img_str = that.feeImgList.join(",");
          that.ownerFeeForm.images = img_str;
          let obj = {
            ...that.ownerFeeForm
          };
          console.log(obj);
          z_add(obj).then(res => {
            if (res.data.code == 1) {
              that.$message.success(res.data.msg);
              that.$router.push("/ownerFeeExpenditure");
            } else {
              that.$message.error(res.data.msg);
              this.$refs.ownerFeeForm.resetFields();
            }
          });
        } else {
          // 校验失败
          that.$message.error("新增失败，请输入正确的内容");
          return false;
        }
      });
    },
    // 图片上传成功
    handleSuccess(file, fileList) {
      var that = this;
      var img_url = fileList.response.data.url;
      console.log("图片上传成功", img_url);
      that.feeImgList.push(img_url);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    //   取消返回首页
    goBack() {
      var that = this;
      that.$router.push("/ownerFeeExpenditure");
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.info_box {
  background-color: #ffffff;
  height: 100%;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.owner_box {
  padding: 45px 30px;
}
.el-main {
  padding: 0;
}
.inpt_size {
  width: 200px;
}
.add_ramark {
  width: 475px;
}
.upload_size {
  width: 230px;
}
.upload_icon {
  font-size: 15px;
  margin-right: 5px;
}
.info_btn {
  width: 200px;
  height: 35px;
}
.el-input__inner {
  background-color: RGB(250, 250, 250);
}
</style>



// WEBPACK FOOTER //
// src/view/owner/OwnerFeeExpenditureAdd.vue